export const ASCII_CODES = {
    ENTER: 13,
    BACK_SPACE: 8,
    ZERO: 48,
    NINE: 57,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
};

export const TEXTS = {
    CUSTOMIZED: "CUSTOMIZED",
    CUSTOMIZE: "Customize",
    MAKE_PAYMENT: "MAKE PAYMENT",
    PROCEED_TO_PAY: "Proceed to Pay",
    PLACE_ORDER: "Place Order",
    VIEW_DETAILED_BILL: "VIEW DETAILED BILL",
    VIEW_DETAILED_BILL_CAPITALIZED: "View Detailed Bill",
    CHANGE: "Change",
    APPLIED: "applied",
    ADD_NEW: "ADD NEW",
    HOME: "Home",
    WORK: "Work",
    OTHER: "Other",
    FRIENDS_AND_FAMILY: "Friends and Family",
    DELIVER_TO_X: "Deliver to {0}",
    ADD_ADDRESS: "Add Address",
    ADD_NEW_ADDRESS: "Add New Address",
    SELECT_ADDRESS: "Select Address",
    MULTIPLE_ADD_IN_LOCATION: "Restaurant is serviceable to multiple saved addresses",
    YOU_ARE_IN_NEW_LOCATION: "You are in a new location!",
    WHERE_TO_DELIVER: "Where would you like us to deliver this order?",
    WHERE_TO_DELIVER_JHS: "Where would you like this delivered?",
    ADDRESS_LIST_ERROR_MSG: "We are unable to load your saved addresses right now",
    RELOAD_ADDRESSES: "Reload Addresses",
    ADD_ADDRESS_TO_PROCEED: "Add Address to Proceed",
    ADD_OR_SELECT_ADDRESS: "Add or Select address",
    YOU_MAY_LIKE: "You May Like",
    OFFER_APPLIED_ON_THE_BILL: "Offer applied on the bill",
    COUPON_SAVINGS: "coupon savings",
    SAVINGS: "savings",
    DEFAULT_TIME: "00h : 00m : 00s",
    TIMER_TEXT: "{0}h : {1}m : {2}s",
    ENDS_IN: "Ends in",
    I_LL_CHOOSE: "I'll Choose",
    REPEAT_LAST: "Repeat Last",
    FREE: "FREE",
    CHANGE_PLAN: "Change Plan",
    REMOVE: "Remove",
    WITH_X_TIP: "(with ₹{0} tip)",
    VEG_ITEM: "Veg Item",
    NON_VEG_ITEM: "Non Veg Item",
    EGG_ITEM: "Egg Item",
    FOR_THIS_LOCATION: "for this location",
    OTHER_AVAIALABLE_ADDRESSES: "Other available addresses",
    COUPONS_AND_OFFERS: "Offers & Benefits",
    DELIVERY_INSTRUCTIONS: "Add delivery instructions",
    DELIVERY_INSTRUCTIONS_UX4: "Delivery Instructions",
    DELIVERY_INSTRUCTION_BENEFIT_TEXT: "Add instructions to get faster delivery and fewer calls from delivery partners",
    CART_DELIVERY_SPEED: "Delivery Type",
    CART_DELIVERY_SPEED_SUB_TEXT: "Your food will always be hot and fresh!",
    CHOOSE_DELIVERY_SPEED: "Choose delivery speed",
    WITH: " with ",
    X_DELIVERY: "{0} Delivery",
    VOICE_DIRECTIONS_TOOLTIP: "You can now add voice directions",
    APPLY: "Apply",
    APPLY_COUPON: "Apply Coupon",
    VIEW_MORE_COUPON: "View more coupons",
    VIEW_ALL_COUPONS: "View all coupons",
    SAVE_ON_ORDER: "Save another {0} on this order",
    SAVE_ON_ORDER_WITH_EXTRA_SAVINGS: "Save {0} on this order + extra {1} on next order with this coupon",
    DELIVERY_FEE_DISCOUNT: "additional discount on Delivery fee",
    TO_X: "to {0}",
    SLOT_TTILE: "Select a delivery slot",
    SLOT_SUBTITLE: "For Tomorrow, {0}",
    BULK_ORDER_SLOT_SUBTITLE: "For {0}",
    SELECT_DELIVERY_SLOT: "Select Delivery Slot",
    INSTANT_OFF: "Instant {0} off!",
    COUPON_SUCCESS_CTA_TEXT: "YAY!",
    ADD_ITEM: "Add item",
    ADDED_ALL_ITEMS: "Yay! you added all the suggested items.",
    COMPLETE_YOUR_MEAL: "Complete your meal",
    COMPLETE_YOUR_MEAL_CAPS: "COMPLETE YOUR MEAL",
    SLA_TO_ANNOTATION: "{0} to {1}",
    SELECT_ORDER_TYPE_HEADING: "Select order type",
    SELECT_ORDER_TYPE_SUBTITLE: "Get it delivered to your seat or Pick up at counter",
    SELECT_ORDER_TYPE_CTA: "Select Order Type",
    ON_PREMISE_TOOLTIP_SEAT_UPDATED: "Seat no. is updated",
    ON_PREMISE_TOOLTIP_ORDER_TYPE_UPDATED: "Order type is updated",
    ON_PREMISE_TOOLTIP_LEFT_ASSET_NAME: "tickFilled16",
    ON_PREMISE_TOOLTIP_LEFT_ASSET_FILL_COLOR: "positive",
    ON_PREMISE_TOOLTIP_LEFT_ASSET_STROKE_COLOR: "text_inverse_Highest_Emphasis",
    DEFAULT_ORDER_TYPE_LABEL: "Order Type",
    DEFAULT_MOBILE_NUMBER_LABEL: "Your mobile no.",
    DEFAULT_SELECT_CTA: "Select",
    DEFAULT_EDIT_CTA: "Edit",
    VERIFY_PNR_CTA: "Enter PNR",
    DELIVERY_DETAILS: "Delivery details",
    TRAVELLER_MOBILE_NO: "Traveller's mobile no.",
};

export const ICONS = {
    MYSTERY_BOX: "Toing/Cart%20Page/OFO_giftcart.png",
    VOICE_DIRECTIONS_TOOLTIP: "4_0_Assets/Delivery_Instructions/voice_icon_4x",
    CINEPOLIS_CHAIR_ICON: "portal/static-assets/icons/seat.png",
    CINEPOLIS_CALL_ICON: "portal/static-assets/icons/call.png",
};

export const DELIVERY_DETAILS_IMAGE_SIZE = {
    HEADER_IMAGE_SIZE: "64",
    ICON_IMAGE_SIZE: "20",
};

export const ACCESSIBILITY_TEXTS = {
    APPLIED_COUPON_SAVING: "You are saving {0} rupees with {1} coupon",
    COUPON_SAVING: "Apply {0} coupon to save {1} rupees",
    ESTIMATED_TIME: "Estimated time for delivery is {0}",
    CHANGE_ADDRESS: "Click here to change delivery address",
    ADD_MORE_ITEMS: "Add more items",
    ADD_MORE_ITEMS_WORTH: "Add items worth {0} to save {1} Click to add more items",
    UNLOCK_COUPON_WIDGET: "Unlock {0} Add items worth {1} to save {2} Click to add more items",
    ADD_ITEM_FOR_FREE: "Add {0} for free",
    ADD_ITEM_FOR_PRICE: "Add {0} for Rupees {1}",
};

export const containerIdForCrossSellM2ItemDetailsBS = "cross-sell-m2-item-details-bs-container";
export const CROSS_SELL_M2_ALL_ITEMS_ADDED = "cross-sell-all-items-added";
export const CROSS_SELL_M2_ALL_ITEMS_ADDED_TIMER = 5000;
export const CROSS_SELL_M2_ALL_ITEMS_ADDED_ANIMATION_TRIGGER_TIMER = 4700;
export const CROSS_SELL_M2_ITEM_DETAILS_PLACEHOLDER =
    "https://media-assets.swiggy.com/swiggy/image/upload/v1691650781/portal/c/placeholder.png";
export const CROSS_SELL_M2_ITEM_PLACEHOLDER =
    "https://media-assets.swiggy.com/swiggy/image/upload/v1691650767/portal/c/placeholder_thumbnail.png";
export const CROSS_SELL_M2_ITEM_ACCESSIBILITY_TEXT_ADD_BUTTON = "Click to add the item";
export const TICKER_REPEAT_COUNT = 3;

export const NO_ITEMS_ADDED = "No items added";
export const RAIN_BG_COLOR = "rain";

export const SAVINGS_CORNER = "Savings Corner";

export const SEE_ALL_COUPONS = "Click to see all coupons.";
export const CLICK_TO = "Click to";
export const CLICK_TO_OPEN = `${CLICK_TO} open`;

export const LOGO_DIMENSION = {
    ONE: "20px",
    BLACK: "24px",
};

export const POP_CROSS_SELL_ICON = "Sunshine/cart/Cafe33_assets/Add.png";
export const POP_CROSS_SELL_ICON_DIMENSIONS = {
    HEIGHT: "26px",
    WIDTH: "26px",
};

export const TOING_CROSS_SELL_ICON = "Toing/Cart%20Page/Add_button_crosssell_2.png";
export const TOING_CROSS_SELL_ICON_DIMENSIONS = {
    HEIGHT: "28px",
    WIDTH: "28px",
};

export const CROSS_SELL_HEADER_LOTTIE_SHOWN = "CROSS_SELL_HEADER_LOTTIE_SHOWN";
